/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBusinessSignUpItem, IBusinessSignUpViewProps, InputID } from './sysco-business-sign-up';

const BusinessSignUpItem: React.FC<IBusinessSignUpItem> = ({ id, wrapper, label, errorMessage, input, isAddressInput, description }) => {
    return (
        <Node {...wrapper}>
            {!isAddressInput && label === 'Phone' ? 'Mobile Phone' : label}
            {!isAddressInput && errorMessage}
            {description && <div>{description}</div>}
            {id === InputID.AccountNo ? (
                <div className='account-number'>
                    <span>067 -</span> <div className='input-wrapper'>{input}</div>
                </div>
            ) : (
                input
            )}
        </Node>
    );
};

const BusinesSignUpView: React.FC<IBusinessSignUpViewProps> = props => {
    const {
        businessSignUp,
        ContainerWrapper,
        businessSignUpForm,
        existingUSBLCustomer,
        renderReSaleDropDown,
        renderSubmitTaxDropDown,
        renderSalesTaxWarning,
        renderStyleOfBusiness,
        renderCusineType,
        renderTaxNode,
        renderStore,
        renderTermsAndConditions,
        renderTaxPolicy,
        renderModal,
        phonePolicy,
        emailPolicy,
        renderExitModal,
        existingValidationErrorModal,
        existingValidationSuccessModal,
        renderStyleChangeModal
    } = props;

    const { FormWrapper, buttons, items } = businessSignUpForm;
    return (
        <Module {...businessSignUp}>
            {renderModal}
            {renderExitModal}
            {existingValidationErrorModal}
            {existingValidationSuccessModal}
            {renderStyleChangeModal}
            <Node {...ContainerWrapper}>
                {/* {heading} */}
                <Node {...FormWrapper}>
                    {existingUSBLCustomer}
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            if (
                                item.id === InputID.FirstName ||
                                item.id === InputID.LastName ||
                                item.id === InputID.CompanyName ||
                                item.id === InputID.Email ||
                                item.id === InputID.AccountNo ||
                                item.id === InputID.StreetAddress ||
                                item.id === InputID.ZipCode ||
                                item.id === InputID.Phone
                            ) {
                                return <BusinessSignUpItem key={item.id} {...item} />;
                            } else {
                                return null;
                            }
                        })}
                    <>
                        {renderReSaleDropDown}
                        {renderSubmitTaxDropDown}
                        {renderSalesTaxWarning}
                        {renderStyleOfBusiness}
                        {renderCusineType}
                        {renderStore}
                        {items &&
                            items.map((item: IBusinessSignUpItem) => {
                                if (item.id === InputID.NetworkId) {
                                    return <BusinessSignUpItem key={item.id} {...item} />;
                                } else {
                                    return null;
                                }
                            })}

                        {renderTaxNode}
                    </>
                    <>
                        {items &&
                            items.map((item: IBusinessSignUpItem) => {
                                if (item.id === InputID.Address || item.id === InputID.Comment) {
                                    return <BusinessSignUpItem key={item.id} {...item} />;
                                } else {
                                    return null;
                                }
                            })}
                    </>
                    {renderTermsAndConditions}
                    {renderTaxPolicy}
                    {emailPolicy}
                    {phonePolicy}
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{button}</React.Fragment>;
                        })}
                </Node>
            </Node>
        </Module>
    );
};

export default BusinesSignUpView;
